/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Validations,
  Validations$inboundSchema,
  Validations$Outbound,
  Validations$outboundSchema,
} from "./validations.js";

/**
 * The controlled device namespace.
 */
export const Namespace = {
  Setting: "setting",
  Metric: "metric",
  Output: "output",
  Condition: "condition",
  ControlPoint: "control-point",
} as const;
/**
 * The controlled device namespace.
 */
export type Namespace = OpenEnum<typeof Namespace>;

/**
 * Kind of the reading
 */
export const RefValueKind = {
  Number: "number",
  Boolean: "boolean",
  Enum: "enum",
  Schedule: "schedule",
  Sequence: "sequence",
  String: "string",
} as const;
/**
 * Kind of the reading
 */
export type RefValueKind = OpenEnum<typeof RefValueKind>;

/**
 * A reference to a reading or setting.
 */
export type Ref = {
  /**
   * Human-readable display name of the property, when configured (currently only control points).
   */
  displayName?: string | undefined;
  /**
   * Universally unique identifier
   */
  id: string;
  /**
   * The key of the reading or setting.
   */
  key?: string | undefined;
  /**
   * The controlled device namespace.
   */
  namespace: Namespace;
  /**
   * The units of the reading or setting. This is included so we can render units before we have any values.
   */
  units?: string | undefined;
  /**
   * Validation constraints for a reading or setting value.
   */
  validations?: Validations | undefined;
  /**
   * Kind of the reading
   */
  valueKind: RefValueKind;
};

/** @internal */
export const Namespace$inboundSchema: z.ZodType<
  Namespace,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(Namespace);
/** @internal */
export const Namespace$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  Namespace
> = openEnums.outboundSchema(Namespace);

/** @internal */
export const RefValueKind$inboundSchema: z.ZodType<
  RefValueKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(RefValueKind);
/** @internal */
export const RefValueKind$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  RefValueKind
> = openEnums.outboundSchema(RefValueKind);

/** @internal */
export const Ref$inboundSchema: z.ZodType<Ref, z.ZodTypeDef, unknown> = z
  .object({
    display_name: types.optional(types.string()),
    id: types.string(),
    key: types.optional(types.string()),
    namespace: Namespace$inboundSchema,
    units: types.optional(types.string()),
    validations: types.optional(Validations$inboundSchema),
    value_kind: RefValueKind$inboundSchema,
  }).transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "value_kind": "valueKind",
    });
  });
/** @internal */
export type Ref$Outbound = {
  display_name?: string | undefined;
  id: string;
  key?: string | undefined;
  namespace: string;
  units?: string | undefined;
  validations?: Validations$Outbound | undefined;
  value_kind: string;
};

/** @internal */
export const Ref$outboundSchema: z.ZodType<Ref$Outbound, z.ZodTypeDef, Ref> = z
  .object({
    displayName: z.string().optional(),
    id: z.string(),
    key: z.string().optional(),
    namespace: Namespace$outboundSchema,
    units: z.string().optional(),
    validations: Validations$outboundSchema.optional(),
    valueKind: RefValueKind$outboundSchema,
  }).transform((v) => {
    return remap$(v, {
      displayName: "display_name",
      valueKind: "value_kind",
    });
  });

export function refToJSON(ref: Ref): string {
  return JSON.stringify(Ref$outboundSchema.parse(ref));
}
export function refFromJSON(
  jsonString: string,
): SafeParseResult<Ref, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Ref$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Ref' from JSON`,
  );
}
